import React from 'react';
import Text from '../../../text';
const MonthCalendarTitle = ({ lang, target, onChangeMode }) => (React.createElement(Text, { lang: lang, fontType: "Subheading", color: "INK_800", onClick: () => onChangeMode('YEAR') }, target.format('YYYY')));
export default MonthCalendarTitle;
//# sourceMappingURL=MonthCalendarTitle.js.map